/* eslint-disable */
import Loadding from '../components/common/Loadding';

const loadding = {
  install(Vue){
		const LoadLayer = Vue.extend(Loadding);
		const $vm = new LoadLayer();
		const cm = $vm.$mount();
		document.body.appendChild(cm.$el);
		Vue.prototype.$loading = {
			showLoadding(upText, downText){
				$vm.upText = upText;
				$vm.downText = downText;
				$vm.show();
			},
			hideLoadding(){
				$vm.hide();
			},
			status(){
				return $vm.status;
			}
		}
	}
}

export default loadding;
